import React, {useState} from "react"
import classes from "./Profile.module.scss"
import {useAppDispatch, useAppSelector} from "../../../hooks/redux"
import getRole from "../../../utils/getRole"
import {useFormik} from "formik"
import Input from "../../generic/dataEntry/Input/Input"
import Button from "../../generic/buttons/Button"
import {userUpdate} from "../../../store/actions/authActions"
import ModalChangePassword from "../modals/ModalChangePassword/ModalChangePassword"
import ModalSuccess from "../modals/ModalSuccess/ModalSuccess"
import {authSlice} from "../../../store/slices/authSlice"

function Profile() {

  const dispatch = useAppDispatch()
  const {error} = useAppSelector(state => state.auth)
  const {fio, phone, email, role_id} = useAppSelector(state => state.auth.user)
  const role = getRole(role_id)
  const [firstWord, secondWord] = fio.split(" ")
  const firstChar = firstWord !== undefined ? firstWord.charAt(0) : ''
  const secondChar = secondWord !== undefined ? secondWord.charAt(0) : ''
  const [modalChangePasswordShown, modalChangePasswordToggle] = useState(false)
  const [modalChangePasswordSuccessShown, modalChangePasswordSuccessToggle] = useState(false)
  const [modalUserUpdatedShown, modalUserUpdatedToggle] = useState(false)

  const initialValues = {
    fio,
    phone,
    email
  }

  const {values, touched, handleChange, handleSubmit} = useFormik({
    initialValues,
    onSubmit: async (values) => {
      const isUserUpdated = await dispatch(userUpdate(values))

      if (isUserUpdated) {
        dispatch(authSlice.actions.clearError())
        modalUserUpdatedToggle(true)
      }
    }
  })

  const changeHandler = (e: React.ChangeEvent) => {
    handleChange(e)
    const fieldName: any = e.target.getAttribute('name')

    if (error[fieldName]) {
      dispatch(authSlice.actions.clearFieldError(fieldName))
    }
  }

  const modalChangePassword = modalChangePasswordShown &&
    <ModalChangePassword
      modalToggle={modalChangePasswordToggle}
      changeSuccess={modalChangePasswordSuccessToggle}
    />

  const modalChangePasswordSuccess = modalChangePasswordSuccessShown &&
    <ModalSuccess
      close={() => modalChangePasswordSuccessToggle(false)}
      title={"Пароль изменен!"}
    />

  const modalUserUpdated = modalUserUpdatedShown &&
    <ModalSuccess
      close={() => modalUserUpdatedToggle(false)}
      title={"Данные обновлены!"}
    />

  return (
    <>
      <div className={classes.wrap}>
        <div className={classes.info}>
          <div className={classes.info_square}>{`${firstChar}${secondChar}`}</div>
          <div className={classes.info_details}>
            <div className={classes.info_name}>{fio}</div>
            <div className={classes.info_role}>{role?.name}</div>
          </div>
        </div>
        <form
          className={classes.form}
          onSubmit={handleSubmit}
        >
          <div className={classes.form_fields_list}>
            <div className={classes.form_field}>
              <Input
                value={values.fio}
                onChange={(e: React.ChangeEvent) => {
                  changeHandler(e)
                }}
                name={"fio"}
                label={"Полное имя (ФИО)"}
                valid={!error.fio}
                errorMessage={error.fio}
                touched={touched.fio}
                required
              />
            </div>
            <div className={classes.form_field}>
              <Input
                mask="+7 (999) 999-99-99"
                value={values.phone}
                onChange={(e: React.ChangeEvent) => {
                  changeHandler(e)
                }}
                name={"phone"}
                label={"Телефон"}
                valid={!error.phone}
                errorMessage={error.phone}
                touched={touched.phone}
                required
              />
            </div>
            <div className={classes.form_field}>
              <Input
                value={values.email}
                onChange={(e: React.ChangeEvent) => {
                  changeHandler(e)
                }}
                name={"email"}
                label={"E-mail"}
                valid={!error.brigade}
                errorMessage={error.brigade}
                touched={touched.email}
                required
              />
            </div>
            <div className={classes.form_field}>
              <Button
                color={"white"}
                onClick={() => modalChangePasswordToggle(true)}
              >Сменить пароль</Button>
            </div>
          </div>
          <div className={classes.form_bottom}>
            <Button className={classes.form_submit} type={"submit"}>Сохранить</Button>
          </div>
        </form>
      </div>
      {modalChangePassword}
      {modalChangePasswordSuccess}
      {modalUserUpdated}
    </>
  )
}

export default Profile